import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPdf = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 21,
	viewBox: "0 0 20 21",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M11 0.00134085V2.24136C11 3.04633 11 3.71069 11.0442 4.25189C11.0901 4.81398 11.1887 5.33069 11.436 5.81602C11.8195 6.56867 12.4314 7.18059 13.184 7.56409C13.6694 7.81138 14.1861 7.90994 14.7482 7.95587C15.2894 8.00008 15.9537 8.00007 16.7587 8.00006H18.9987C19.0001 8.16785 19.0001 8.34599 19 8.53707V10H1V7.35711C0.999991 6.2734 0.999983 5.39927 1.05782 4.69142C1.11737 3.96257 1.24318 3.32238 1.54497 2.73009C2.02434 1.78928 2.78924 1.02438 3.73005 0.545011C4.32234 0.243221 4.96253 0.117411 5.69138 0.057861C6.39926 2.49557e-05 7.27341 3.29015e-05 8.3572 4.29015e-05L10.4633 2.08183e-05C10.6543 -3.41484e-05 10.8323 -8.53778e-05 11 0.00134085Z",
			fill: "#DC2626"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M13 0.282541V2.20006C13 3.05664 13.0008 3.63893 13.0376 4.08902C13.0734 4.52744 13.1383 4.75164 13.218 4.90804C13.4097 5.28436 13.7157 5.59033 14.092 5.78207C14.2484 5.86176 14.4726 5.92669 14.911 5.96251C15.3611 5.99928 15.9434 6.00006 16.8 6.00006H18.7175C18.6005 5.66679 18.4483 5.3464 18.2632 5.0444C17.953 4.53818 17.5277 4.11309 16.9132 3.49897L15.4997 2.08544C14.8862 1.47173 14.4615 1.04681 13.9556 0.736841C13.6537 0.551781 13.3333 0.399591 13 0.282541Z",
			fill: "#DC2626"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M1 12C0.447715 12 0 12.4477 0 13V20C0 20.5523 0.447715 21 1 21C1.55228 21 2 20.5523 2 20V19H2.5C4.433 19 6 17.433 6 15.5C6 13.567 4.433 12 2.5 12H1ZM2.5 17H2V14H2.5C3.32843 14 4 14.6716 4 15.5C4 16.3284 3.32843 17 2.5 17Z",
			fill: "#DC2626"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M8 12C7.44772 12 7 12.4477 7 13V20C7 20.5523 7.44772 21 8 21H8.5C10.9853 21 13 18.9853 13 16.5C13 14.0147 10.9853 12 8.5 12H8ZM11 16.5C11 17.7095 10.1411 18.7184 9 18.95V14.05C10.1411 14.2816 11 15.2905 11 16.5Z",
			fill: "#DC2626"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M15 12C14.4477 12 14 12.4477 14 13V20C14 20.5523 14.4477 21 15 21C15.5523 21 16 20.5523 16 20V18H19C19.5523 18 20 17.5523 20 17C20 16.4477 19.5523 16 19 16H16V14H19C19.5523 14 20 13.5523 20 13C20 12.4477 19.5523 12 19 12H15Z",
			fill: "#DC2626"
		})
	]
});
const ForwardRef = forwardRef(SvgPdf);
export default ForwardRef;
